// التحيّة بحسب الساعة — **في مكانٍ واحد**.
//
// كانت مكتوبةً مرّتين (رسالةُ الدخول والصفحةُ الرئيسية)، ثم طُلبت ثالثةً في ترويسة
// الهاتف (قرار المالك 22/09/2026: «عاوز من الموبايل يقوله صباح الخير، إزيك يا أحمد
// شوقي»). وثلاثُ نسخٍ من جملةٍ واحدة تفترق: تُعدَّل واحدةٌ وتبقى الأخريان.
//
// والساعةُ ساعةُ القاهرة لا ساعةَ الجهاز: موظفٌ في بلدٍ آخر يقرأ تحيّةَ يومِ المكتب.
import { cairoParts } from './format.ts';

/**
 * نهارٌ أم ليل — بساعة القاهرة، وبنفس فاصل التحيّة (السادسة مساءً).
 *
 * ويُقرأ من مكانين: التحيّةُ نفسُها، ورسمُها (شمسٌ تضحك أو قمرٌ نائم). وفاصلٌ واحد
 * لهما فلا يُقال «صباح الخير» تحت قمرٍ نائم.
 */
export const isDaytimeCairo = (at: Date = new Date()): boolean => cairoParts(at).hour < 18;

/** «صباح الخير» قبل السادسة مساءً، و«مساء الخير» بعدها — بساعة القاهرة. */
export function timeGreetingAr(at: Date = new Date()): string {
  return isDaytimeCairo(at) ? 'صباح الخير' : 'مساء الخير';
}

/**
 * تحيّةٌ باسم صاحبها.
 *
 * **والفاصل شَرطةٌ لا «يا»** (قرار المالك 22/09/2026: «جملة تصبح على خير يا أحمد شوقي
 * خلّيها ---- أحمد شوقي»): «يا فلان» نداءٌ في منتصف عبارة، والشَرطةُ تجعل الاسم عنوانًا
 * للسطر — يُقرأ بلمحة ولا يُقرأ كجملةٍ تُنطق.
 *
 * @param short `true` بالاسم الأول وحده؛ وإلّا بالاسم كاملًا كما هو مسجَّل.
 */
export function greetAr(name: string, opts: { short?: boolean; at?: Date } = {}): string {
  const clean = name.trim().replace(/\s+/g, ' ');
  const who = opts.short === true ? clean.split(' ')[0] : clean;
  const hi = timeGreetingAr(opts.at);
  return who === '' ? hi : `${hi} — ${who}`;
}
